export const EDIT_CUSTOMERS_LOCATION_REQUEST = 'EDIT_CUSTOMERS_LOCATIONS_REQUEST';
export const EDIT_CUSTOMERS_LOCATION_SUCCESS = 'EDIT_CUSTOMERS_LOCATIONS_SUCCESS';
export const EDIT_CUSTOMERS_LOCATION_FAILURE = 'EDIT_CUSTOMERS_LOCATIONS_FAILURE';
